// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"9ce6341e","65":"7eeb5a0d","372":"ca34d295","409":"fc93fafd","448":"5c892329","610":"9651435a","728":"a9c55dbb"}[chunkId] + ".chunk.js";
};